export default __webpack_public_path__ + "static/media/Double-Flare.e84fbb7a.jpg";